<div class="div-arriere-plan-action" (click)="clicAction($event)"></div>
<div [ngClass]="isMobile ? 'div-global-action-mob' : ''" class="div-global-action" (click)="clicAction($event)">
  <div id="center-square" class="w-full">
    <div class="flex-row content-between">
      <div class="bg-yellow popup-test-pill flex content-center align-items-center">
        <p class="bold dark-blue no-margin text-xs">
          ESPACE TEST ACTIVÉ
          <i class="pi pi-check dark-blue"
            style="margin-left: 5px; font-size: 10px; font-weight: 900; stroke-width: 5px;"></i>
        </p>
      </div>
      <div class="cross" (click)="cancelDetails(false)">
      </div>
    </div>

    <div class="text-center">
      <p class="dark-blue bold text-md no-margin text-center">VOUS POUVEZ CONSULTER LES LISTES ET/OU LES
        CANDIDATS
        ET TESTER LE VOTE POUR VÉRIFIER VOTRE BULLETIN.</p>
      <!-- <p class="dark-blue test-md text-center no-margin">Cet espace de test vous permet de vous familiariser avec le
        scrutin.</p> -->
    </div>
    <img src="assets/test-icon.svg" alt="" class="mb-10 mt-10 margin-auto" width="63px">

    <div class="bg-yellow p-20" style="border-radius: 10px;">
      <div class="flex-row align-items-center gap-10">
        <span class="exclamation dark-blue bold">!</span>
        <p class="dark-blue text-md no-margin"><span class="bold">Rassurez-vous </span>: Votre bulletin ne sera pas
          déposé dans l'urne, aucun vote n'est pris en compte.</p>

      </div>
    </div>

    <p class="dark-blue text-md no-margin text-center pointer" (click)="cancelDetails(false)">Ok</p>
  </div>
</div>